<template>
    <vs-card>
        <h4 class="mb-4">Course</h4>
        <div class="cstm_vuexy_table table-responsive">
            <table class="w-full">
                <thead>
                    <tr>
                        <th>Course Name</th>
                        <th>Subject</th>
                        <th>Child</th>
                        <th>Course Class Type</th>
                        <th>Session Frequency</th>
                        <th>Teachers</th>
                        <th style="width: 50px"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(eachData, index) in courseList" :key="index">
                        <td>
                            {{ eachData.name }}
                        </td>
                        <td>
                            {{ eachData.has_all_subject ? "General" : eachData.subjects.length > 0 ? getSubjects(eachData.subjects) : "Not Selected" }}
                        </td>
                        <td>
                            {{ getStudents(eachData.students) }}
                        </td>
                        <td>
                            {{ getType(eachData.course_class_type) }}
                        </td>
                        <td>
                          {{ eachData.no_of_sessions }}
                        </td>
                        <td>
                            <div class="flex items-center course_students_td">
                                <span class="cstm-img-holder" v-for="(eachData, index1) in eachData.tutors" :key="index1">
                                    <vs-tooltip :text="eachData.first_name + ' ' + eachData.last_name" v-if="index1 < 3">
                                        <img
                                        v-if="eachData.picture"
                                        :src="eachData.picture"
                                        alt="user-img"
                                        width="20"
                                        height="20"
                                        class="rounded-full shadow-md cursor-pointer block"
                                      />
                                      <img
                                            v-else
                                            src="@/assets/images/pages/user-circle-solid.svg"
                                            alt="user-img"
                                            width="20"
                                            height="20"
                                            class="rounded-full shadow-md cursor-pointer block"
                                        />
                                    </vs-tooltip>
                                </span>
                                <span class="text-muted pl-2 cursor-pointer" @click="teacherPopup(eachData.tutors)">
                                   {{ eachData.tutors.length > 3 ? "+" : "" }} {{ eachData.tutors.length > 3 ? eachData.tutors.length - 3 : "" }}
                                </span>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="courseList.length==0" class="text-center">
                      <td colspan="5">No Course Found</td>
                    </tr>

                </tbody>
            </table>
            <pagination
              style="float: right"
              :meta="meta"
              @page-change="handlePageChange"
            />

        </div>

    <div v-if="teachertModalPopup">
      <vs-popup
        class="holamundo"
        title="Teachers"
        :active.sync="teachertModalPopup"
      >
        <div class="cstm_vuexy_table table-responsive">
          <table class="w-full">
            <tbody>
              <tr v-for="(eachData, index) in teachers" :key="index">
                <td>
                  <img
                    v-if="eachData.picture"
                    :src="eachData.picture"
                    alt="user-img"
                    width="20"
                    height="20"
                    class="rounded-full shadow-md cursor-pointer block"
                  />
                  <img
                    v-else
                    src="@/assets/images/pages/user-circle-solid.svg"
                    alt="user-img"
                    width="20"
                    height="20"
                    class="rounded-full shadow-md cursor-pointer block"
                  />
                </td>
                <td>{{ eachData.first_name }} {{ eachData.last_name }}</td>
                </tr>
                </tbody>
            </table>
        </div>
      </vs-popup>

      </div>
    </vs-card>
</template>

<script>

import { courseListForprofile } from '@/api/schedulerApi.js'
import Pagination from '@/components/common/pagination'

export default {
  data () {
    return {
      teachertModalPopup: false,
      courseList:[],
      teachers: [],
      course_class_type_list: [
        {
          value: 'self_based',
          name: 'Self Paced Course'
        },
        {
          value: 'online_one_2_one',
          name: 'Online Individual Course'
        },
        {
          value: 'online_one_2_many',
          name: 'Online Group Course'
        },
        {
          value: 'offline_one_2_one',
          name: 'In Person Individual Course'
        },
        {
          value: 'offline_one_2_many',
          name: 'In Person Group Course'
        }
      ],
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      }
    }
  },
  components: {
    Pagination
  },
  mounted () {
  },
  methods: {
    handlePageChange (page) {
      this.meta.current_page = page || 1
      setTimeout(() => {
        this.fetchCourseList()
      }, 0)
    },
    async teacherPopup (teachers) {
      this.teachertModalPopup = true
      this.teachers = teachers
    },
    getType (type) {
      const class_type = this.course_class_type_list.filter((ele) => {
        return ele.value.includes(type)
      })
      if (class_type.length) return class_type[0].name
      return ''
    },
    getSubjects (subjects) {
      const subjectsArray = []
      subjects.forEach((e) => {
        subjectsArray.push(e.subject_name)
      })
      return subjectsArray.join(', ')
    },
    getStudents (students) {
      const studentsArray = []
      students.forEach((e) => {
        studentsArray.push(`${e.first_name} ${e.last_name}`)
      })
      return studentsArray.join(', ')
    },
    async fetchCourseList () {
      const payload = {
        client_user_id: this.$route.params.client_id,
        limit: 10
      }
      this.$vs.loading({
        text: 'Please Wait  ...'
      })
      try {
        const response = await courseListForprofile(
          payload,
          localStorage.getItem('customer_id'),
          this.meta.current_page
        )
        this.courseList = response.data.data.course
        this.meta = response.data.data.meta
      } catch (error) {
        console.log(error)
      } finally {
        this.$vs.loading.close()
      }
    }
  }
}
</script>
